import React from 'react'
import { useTranslation } from 'react-i18next'

import { useCart } from '../../../contexts/CartContext'
import { useOrder } from '../../../contexts/OrderContext'
import { useAddress } from '../../../contexts/AddressContext'
import { useConfig } from '../../../contexts/ConfigContext';
import { useCurrentVendor } from '../../../hooks/useCurrentVendor';
import { getVendorDeliveryFee } from '../../../utils/vendor';
import { formatPrice } from '../../../utils/formatPrice';
import { getAppliedCouponDiscount, getCartSubTotal } from '../../../utils/coupon';

import {
  CartTotalContainer,
  PriceRow,
  TotalTotal
} from './styles'

export const CartTotal = () => {

  const { t } = useTranslation();
  const [configState] = useConfig()
  const vendor = useCurrentVendor()
  const [orderDetail] = useOrder();
  const [cart] = useCart();
  const [, cities] = useAddress();

  const subTotal = getCartSubTotal(cart)

  const currentCity = cities.find(obj => obj.id === orderDetail?.currentLocation);
  const deliveryFee = getVendorDeliveryFee(vendor, currentCity);
  const _coupon = getAppliedCouponDiscount(orderDetail, subTotal)
  const totalAmount = subTotal + deliveryFee - _coupon;

  return (
    <CartTotalContainer>
      <PriceRow>
        <div>{t('Subtotal')}</div>
        <div>{`${formatPrice(subTotal)} ${t(configState?.configs?.currency)}`}</div>
      </PriceRow>
      <PriceRow>
        <div>{t('Delivery')}</div>
        <div>{`${formatPrice(deliveryFee)} ${t(configState?.configs?.currency)}`}</div>
      </PriceRow>
      {_coupon > 0 &&
        <PriceRow>
          <div>{t('Coupon discount')}</div>
          <div>-{formatPrice(_coupon)} {t(configState?.configs?.currency)}</div>
        </PriceRow>
      }
      <TotalTotal>
        <div>{t('Total')}</div>
        <div>{`${formatPrice(totalAmount)} ${t(configState?.configs?.currency)}`}</div>
      </TotalTotal>
    </CartTotalContainer>
  )
}